import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MainCommonPage from './main.common.page';
import { removeUsuarioLocalStorage } from '../../localStorage.util';
import * as actions from '../../app/common/common.action';
import * as materialActions from '../laudo/etapas/material/material.action';
import * as usuarioActions from '../../app/common/usuario/usuario.action';
import  store  from '../../configureStore.util';

class MainCommonContainer extends Component {
  constructor(props) {
    super(props);
    window.addEventListener('keydown', this.updateAtalho.bind(this));
  }

  UNSAFE_componentWillMount() {
    this.props.materialActions.estadoMenuLateral(true);
  }
  componentWillUnmount() {
    this.props.actions.splash(false);
  }

  updateAtalho(event) {
    if (
      event.altKey &&
      event.key !== 'Alt' &&
      event.ctrlKey &&
      event.key !== 'Ctrl' &&
      this.props.detalhes
    ) {
      
      this.props.actions.preencherAtalho('ctrl+alt+' + trim(event.key));
    }
  }

  render() {
    return (
      <MainCommonPage
        splash={this.props.splash}
        history={this.props.history}
        alerta={this.props.alerta}
        detalhes={this.props.detalhes}
        etapa={this.props.etapa}
        listagemExibido={this.props.listagemExibido}
        listagemTotal={this.props.listagemTotal}
        usuario={this.props.usuario}
        onLogoutClick={this.logout.bind(this)}
        goTo={this.goTo.bind(this)}
        pagina={this.props.pagina}
        listagem={this.props.listagem}
        loadListagem={this.props.loadListagem}
        altura={this.props.altura}
        draggablePanelContent={this.props.draggablePanelContent}
        draggablePanelTitle={this.props.draggablePanelTitle}
      />
    );
  }

  goTo(url) {
    this.props.history.push(url);
  }

  logout() {
    this.props.storeAction.dispatch({type:'RESET'});
    removeUsuarioLocalStorage();
    this.props.history.push('/' + process.env.REACT_APP_LOGINPAGE);
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    storeAction: bindActionCreators(store, dispatch),
    actions: bindActionCreators(actions, dispatch),
    usuarioActions: bindActionCreators(usuarioActions, dispatch),
    materialActions: bindActionCreators(materialActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    splash: state.commonReducer.splash,
    altura: state.commonReducer.altura,
    listagemExibido: state.commonReducer.listagemExibido,
    listagemTotal: state.commonReducer.listagemTotal,
    detalhes: state.commonReducer.detalhes,
    etapa: state.commonReducer.etapa,
    pagina: state.commonReducer.pagina,
    listagem: state.commonReducer.listagem,
    loadListagem: state.commonReducer.loadListagem,
    draggablePanelContent: state.commonReducer.draggablePanelContent,
    draggablePanelTitle: state.commonReducer.draggablePanelTitle,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainCommonContainer);



// WEBPACK FOOTER //
// ./src/pages/main/main.common.container.js